<div class="form-row">
  <!--
  Requirement has been removed, save this for later implementation if needed again
  <div class="form-group col-md-4">
    <label for="name">Name</label>
    <input type="text" name='name' [(ngModel)]='this.vehicle.name' [class.is-invalid]='!this.vehicle.name' class="form-control" id="inputEmail4">
  </div> -->
  <div class="form-group col-md-4">
    <label for="registration">Registration</label>
    <input type="text" name='registration' [(ngModel)]='this.vehicle.registration' [class.is-invalid]='!this.vehicle.registration'  class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="vinNumber">VIN</label>
    <input type="text" name='vinNumber' [(ngModel)]='this.vehicle.vinNumber' [class.is-invalid]='!this.vehicle.vinNumber' class="form-control" id="inputPassword4">
  </div>

  <div class="form-group col-md-4">
    <label>Vehicle type</label>
    <select class='form-control' [class.is-invalid]='this.vehicle.vehicleTypeId === -1' (change)='this.vehicle.vehicleTypeId = +$event.target.value; this.vehicle.vehicleType.id = this.vehicle.vehicleTypeId;getSecondaries();'>
      <option value='-1'>Select a vehicle type</option>
      @for (item of this.types; track item) {
        <option [value]='item.id' [selected]='this.vehicle.vehicleTypeId === item.id'>{{ item.name }}</option>
      }
    </select>
  </div>

  @if (this.secondaryTypes.length > 0) {
    <div class="form-group col-md-4">
      <label>Secondary Vehicle Type</label>
      <select class='form-control' (change)='updateSecondaries($event)'>
        <option value='-1'>Select a Secondary vehicle type</option>
        @for (item of this.secondaryTypes; track item) {
          <option [value]='item.id' [selected]='this.vehicle.secondaryVehicleTypeId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  }

  @if (this.vehicle.vehicleTypeId !== 7) {
    <div class="form-group col-md-4">
      <label>Fuel type</label>
      <select
        class='form-control'
        [class.is-invalid]='this.vehicle.fuelTypeId === -1'
        (change)='this.vehicle.fuelTypeId = +$event.target.value; this.vehicle.fuelType.id = this.vehicle.fuelTypeId'>
        <option value='-1'>Select a fuel type</option>
        @for (item of this.fuelTypes; track item) {
          <option [value]='item.id' [selected]='this.vehicle.fuelTypeId === item.id'>{{ item.name }}</option>
        }
      </select>
    </div>
  }
  <div class="form-group col-md-4">
    <label for="make">Make</label>
    <input type="text" name='make' [(ngModel)]='this.vehicle.make' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="model">Model</label>
    <input type="text" name='model' [(ngModel)]='this.vehicle.model' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="vinNumber">Tare Weight ({{this.vehicleWeightUnit}})</label>
    <input type="text" name='vinNumber' [(ngModel)]='this.vehicle.tareWeight' class="form-control" id="inputPassword4">
  </div>
  <div class="form-group col-md-4">
    <label for="purchaseDate">Purchase Date</label>
    <input type="date" name='purchaseDate' [(ngModel)]='this.vehicle.purchaseDate'  class="form-control" id="inputPassword4">
  </div>

  <div class="form-group col-md-4">
    <label>Depot</label>
    <ng-select
      [(ngModel)]="this.vehicle.depotId"
      (change)='updateDepot($event)'>
      @for (item of this.depots; track item) {
        <ng-option [value]='item.id'>{{ item.name }}</ng-option>
      }
    </ng-select>
  </div>

  <div class="form-group col-md-4">
    <label for="inputPassword4">Preferred Driver</label>
    <ng-select [(ngModel)]="this.vehicle.driverId" (change)='this.vehicle.driverId = +$event'>
      @for (item of this.drivers; track item) {
        <ng-option [value]='item.id'>{{ item.firstName }} {{ item.lastName }}</ng-option>
      }
    </ng-select>
  </div>

</div>

<div class='form-row'>
  <div class="form-group col-md-12">
    <label for="inputPassword4">Notes</label>
    <textarea name='notes' [(ngModel)]='this.vehicle.notes' class="form-control"></textarea>
  </div>
</div>

<div class='form-row'>
  <div class='form-group'>
    <label>Active?</label>
    <input type='checkbox'
      [(ngModel)]="this.vehicle.active"
      [ngModelOptions]="{standalone: true}"/>
  </div>
</div>
